// SAWA branding constants (fork of Sable, AGPL-3.0). Keep user-visible product identity here.
export const APP_NAME = 'SAWA';
export const APP_ORIGIN = 'https://app.sawa.chat';
// AGPL-3.0 §13: corresponding source of this build, served by the SAWA web deployment.
export const SOURCE_URL = 'https://app.sawa.chat/source/';
export const SUPPORT_URL = 'https://sawa.chat';
export const UPSTREAM_NAME = 'SAWA';
export const UPSTREAM_URL = 'https://github.com/SableClient/Sable';
// Where in-app bug reports go. Set an organisation mailbox (e.g. it-support@yourcompany) to get prefilled emails;
// empty = open SUPPORT_URL. Reports never go to a public issue tracker.
export const SUPPORT_EMAIL: string = '';
// Accounts are provisioned in Keycloak (via MAS): hide self-registration and the legacy SSO button when OIDC is available.
export const ACCOUNTS_MANAGED_EXTERNALLY: boolean = true;
// Classic /sync is the tested path for SAWA; hide the sliding-sync opt-in on the login screen.
export const SHOW_SLIDING_SYNC_OPTION: boolean = false;
// Brand promise / primary tagline (sawa-brand/docs/brand-manual.md §1). Arabic: 'سوا، وبخصوصية.'
export const BRAND_TAGLINE = 'Together, privately.';
